export default "/profile/images/whatsapp_btn.svg?08e72f623ba25dd82583aaa013fec76a";